import $ from 'jquery';

jQuery(function ($) {

   

    //Add/remove resource to favorites from resource page.
    jQuery('.favorite-form').on('submit', function (e) {
        e.preventDefault();
        const id = e.currentTarget[0].value
        const form = jQuery(this);
        form.find('button').addClass('favorite-form__submit--loading');
        jQuery.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php',
            dataType: "json",
            data: { action: 'get_ajax_handle_favorite_resources', id },
            success: function (response) {
                if (response[0] === 'added') {
                    form.find('button').addClass('favorite-form__submit--added');
                } else {
                    form.find('button').removeClass('favorite-form__submit--added');
                };
                form.find('button').removeClass('favorite-form__submit--loading');
            }
        });
    });

    //Add/remove resource to favorites from libary page.
    jQuery('#library_resource_facets_container').on('click', 'form', function (e) {
        e.preventDefault();
        const id = e.currentTarget[0].value
        const form = jQuery(this);
        form.find('button').addClass('favorite-form__submit--loading');
        jQuery.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php',
            dataType: "json",
            data: { action: 'get_ajax_handle_favorite_resources', id },
            success: function (response) {
                if (response[0] === 'added') {
                    form.find('button').addClass('favorite-form__submit--added');
                } else {
                    form.find('button').removeClass('favorite-form__submit--added');
                };
                form.find('button').removeClass('favorite-form__submit--loading');
                jQuery('#library_resource_facets_container').attr('favorites', response[1]);
            }
        });
    });

    //Remove resource from dashboard.
    jQuery('.handle_favorite').on('submit', function (e) {
        e.preventDefault();
        const id = e.target[0].defaultValue;
        jQuery(this).find('.ajax_spinner').css('display', 'block');
        jQuery(this).find('.favorite_minus_symbol').css('display', 'none');
        jQuery(this).find('.favorite_remove_label').css('display', 'none');
        jQuery.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php',
            dataType: "json",
            data: { action: 'get_ajax_handle_favorite_resources', id },
            success: function (response) {
                if (jQuery('.library_resource_card').length > 1) {
                    jQuery('#favorite_' + id).remove();
                } else {
                    jQuery('#favorite_' + id).remove();
                    jQuery('.library_resource_filter').remove();
                    jQuery('#dashboard_favorites_container').append('<p>You don\'t have any favorite resources. Explore the <a href="/library">Resource Library</a> to add some!</p>');
                };
            }
        });
    });

    //Handle library selection from dashboard

    /*
    jQuery('#library_select_agency').on('change', (e) => {
        const agency = e.target.value;
        window.location.replace(`/library/?_agency=${agency}`);
    });
    jQuery('#library_select_type').on('change', (e) => {
        const agency = e.target.value;
        window.location.replace(`/library/?_type=${agency}`);
    });


    */



    jQuery('#grant_library_button').click(function(e){

        e.preventDefault();

        var query = '?1=1';

        const agency  = jQuery('#library_select_agency').val();

        if(agency != 'any'){

            query += "&_agency="+agency;
        }

        const type  = jQuery('#library_select_type').val();

        if(type != 'any'){

            query += "&_type="+type;
        }

       window.location.replace('/library/'+query);
    })

    //Handle library resource sorting
    jQuery('.filter_option').on('click', function () {

        
        const filter = jQuery(this).attr('sort');
        jQuery('.filter_option').removeClass('filter_option--selected');
        jQuery(this).addClass('filter_option--selected');
        jQuery(".library_resource_card").sort(sortSavedResources).appendTo('#dashboard_favorites_container');
        function sortSavedResources(a, b) {
            switch (filter) {
                case 'agency':
                    return (jQuery(b).attr('agency')) < (jQuery(a).attr('agency')) ? 1 : -1;
                case 'dd':
                    return (jQuery(b).attr('dd')) < (jQuery(a).attr('dd')) ? 1 : -1;
                case 'title':
                    return (jQuery(b).attr('title')) < (jQuery(a).attr('title')) ? 1 : -1;
            };
        };
    });

    //Handle view mode
    jQuery('#view_mode_trigger').on('click', function () {
        const cards = jQuery('.library_resource_card__content');
        if (!jQuery(this).hasClass('library_resource_filter__view_mode_icon--expanded')) {
            [...cards].forEach(card => jQuery(card).removeClass('library_resource_card__content--collapsed'));
            jQuery(this).addClass('library_resource_filter__view_mode_icon--expanded');

        } else {
            [...cards].forEach(card => jQuery(card).addClass('library_resource_card__content--collapsed'));
            jQuery(this).removeClass('library_resource_filter__view_mode_icon--expanded');
        };
    });

    //Facets hooks
    document.addEventListener('facetwp-loaded', function () {
        const favorites = jQuery('#library_resource_facets_container').attr('favorites');
        const forms = jQuery('.favorite-form');
        const cards = jQuery('.library_resource_card__content');
        //Updates class based on favorite state.
        [...forms].map((form) => {
            if (favorites.indexOf(form[0].attributes[2].nodeValue) != -1) {
                jQuery(form).find('.favorite-form__submit').addClass('favorite-form__submit--added');
            } else {
            };
        });
        //Updates class based on selected view mode.
        if (jQuery('#view_mode_trigger').hasClass('library_resource_filter__view_mode_icon--expanded')) {
            [...cards].forEach(card => jQuery(card).removeClass('library_resource_card__content--collapsed'));
            jQuery(this).addClass('library_resource_filter__view_mode_icon--expanded');
        }
    });

    //Handle Filter visibility for mobile
    jQuery('#gis_filter_trigger').on('click', function () {
        const position = jQuery('#gis_facets_container').offset();
        jQuery('#gis_facets_container').toggleClass('filter_facets--expanded');
        window.scrollTo(0, position.top - 20);
    })

    jQuery(window).on('scroll', function () {
        if (window.location.pathname === 'library') {
            const position = jQuery('#gis_facets_container').offset();
            console.log(window.location);
            if (window.scrollY > position.top + 70) {
                jQuery('#gis_filter_trigger').css({ position: 'fixed', top: 135 });
            } else if (window.scrollY <= position.top + 70) {
                jQuery('#gis_filter_trigger').css({ position: 'absolute', top: '' });
            }
        }
    })




    jQuery(function() {
        jQuery( ".accordion" ).accordion({collapsible: true});
      });

     jQuery( ".accordion h3" ).click(function(){

        jQuery(this).find('i').toggleClass('fa-plus-circle fa-minus-circle')
     })


   
  jQuery('.view-toggle').click(function(){

    jQuery('.view-mode').show();
    jQuery('.edit-mode').hide();

  })

  jQuery('.edit-toggle').click(function(){

    jQuery('.edit-mode').show();
    jQuery('.view-mode').hide();
    
  })


  var $videoSrc;  
  $('.tutorial').click(function() {
      $videoSrc = $(this).data( "src" );
  });
  $('#videoModal').on('shown.bs.modal', function (e) {
    $("#video").attr('src',$videoSrc + "?autoplay=1&modestbranding=1&showinfo=0" ); 
  })
  $('#videoModal').on('hide.bs.modal', function (e) {
        $("#video").attr('src',$videoSrc); 
  }) 

function carouselNormalization() {

var items = jQuery('#featuredsliderindicator .carousel-inner .carousel-item'), //grab all slides
    heights = [], //create empty array to store height values
    tallest; //create variable to make note of the tallest slide
 
if (items.length) {

   
    function normalizeHeights() {
        items.each(function() { //add heights to array
            heights.push(jQuery(this).height()); 
        });
        tallest = Math.max.apply(null, heights); //cache largest value
        items.each(function() {
            jQuery(this).css('min-height',tallest + 'px');
        });
    };
    normalizeHeights();

    jQuery(window).on('resize orientationchange', function () {
        tallest = 0, heights.length = 0; //reset vars
        items.each(function() {
            jQuery(this).css('min-height','0'); //reset min-height
        }); 
        normalizeHeights(); //run it again 
    });
}
}
carouselNormalization()


});